import { OrderCondition as BookingConditions } from '@chr/online-shared-ui-constants';
import { StatusTag } from "@chr/eds-react";
import { useTranslation } from '@chr/online-shared-ui-localizations';

export interface BookingConditionsProps {
  conditionRDN?: number;
}

const BookingConditionBadge = ({ conditionRDN }: BookingConditionsProps) => {
  const translate = useTranslation();

  let badgeLabel: string;
  let severity: 'positive' | 'neutral' | 'warning' | 'urgent' | 'negative' | undefined;

  switch (conditionRDN) {
    case BookingConditions.ON_HOLD:
      badgeLabel = translate('On Hold');
      severity = "neutral";
      break;
    case BookingConditions.ACTIVE:
      badgeLabel = translate('Active');
      severity = "positive";
      break;
    case BookingConditions.CANCELLED:
      badgeLabel = translate('Cancelled');
      severity = "neutral";
      break;
    case BookingConditions.REJECTED:
      badgeLabel = translate('Rejected');
      severity = "neutral";
      break;
    case BookingConditions.WAITING_ON_ACCEPTANCE:
      badgeLabel = translate('Waiting on Acceptance');
      severity = "neutral";
      break;
    default:
      return null;
  }

  return <StatusTag label={badgeLabel} severity={severity} size='compact' labelSize='small' />;
};

export default BookingConditionBadge;
